import React, { useState, useEffect } from "react";
import { Carousel, Spinner } from "react-bootstrap";
import "./main_banner.css";
import { getStaticUrl } from "../../../../utils/getStaticUrl";
import { getJsonFromStorage } from "../../../../utils/getJsonFromStorage";

function MainBanner() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const jsonData = await getJsonFromStorage("banners.json");
        if (jsonData && jsonData.banners) {
          setBanners(jsonData.banners.map(getStaticUrl));
        } else {
          setError(true);
        }
      } catch (e) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  if (loading) {
    return (
      <div className="banner-loading">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="banner-error">
        <p>No se pudieron cargar los banners.</p>
      </div>
    );
  }

  return (
    <Carousel fade interval={null}>
      {banners.map((src, index) => (
        <Carousel.Item key={index}>
          <img
            className="d-block w-100 main-banner-img"
            src={src}
            alt={`Slide ${index + 1}`}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default MainBanner;
